import { createElement, type ReactNode } from 'react';
import { useFela } from 'react-fela';

import type { Theme } from '@/styles/theme';

import { container, type TextVariant } from './Text.rules';

export interface TextProps {
    elementType?: string;
    color?: keyof Theme['colors'];
    variant?: TextVariant;
    customStyle?: typeof container;
    className?: string;
    preserveNewLines?: boolean;
    'data-testid'?: string;
    children: ReactNode;
}

export const Text = ({
    children,
    color = 'black',
    variant = 'ParagraphNormalRegular',
    className = '',
    elementType = 'p',
    preserveNewLines = false,
    customStyle,
    'data-testid': dataTestId,
}: TextProps) => {
    const { css } = useFela({
        color,
        variant,
        preserveNewLines,
    });

    return createElement(
        elementType,
        {
            className: `Text ${css(container, customStyle)} ${className}`,
            'data-testid': dataTestId,
        },
        children,
    );
};
